var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorse1Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.15 115.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2e2e2e;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #747474;\n      }\n\n      .cls-5 {\n        stroke-width: .3px;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        stroke: #2e2e2e;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        stroke-dasharray: 0 0 3 3;\n      }\n\n      .cls-6, .cls-8, .cls-9 {\n        stroke-linecap: round;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #231f20;\n      }\n\n      .cls-7 {\n        stroke-width: .15px;\n      }\n\n      .cls-8 {\n        stroke-width: .23px;\n      }\n\n      .cls-8, .cls-9 {\n        stroke: #fff;\n      }\n\n      .cls-9 {\n        stroke-width: .25px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.27,114.5h4.85s3.49.1,7.15,0h5.5c.5,0,2.29-9.84,2.63-11.26l1.1-5.3,1.74-.02,1.53,17.08c.32-.24,3.88.34,4.5,0,3,0,2.28.07,5.5,0,3.54-.09,3.54-.15,4,0,.25.08.77-8.59,1-8.5.5,0,.42-5.81.5-7.5.32-6.81.45-13.81-1-22-.53-2.17.49-2.22-1.8-6.45-.18.12-1.48.48-1.83.7-7.79,4.81-16.38,3.98-17.41,3.87-2.99-.33-4.41-1.01-9.34-1.37-1.47-.11-3.01-.14-3.77-.15l-1.35,12.89-2.5,15.85-1,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.32,4.68c-.99,3.59-.67,7.14-.67,7.14,0,0,.15,1.62.5,2.12,1.08,1.57.04,1.64,2.82,2.68l7.82,1.73c.32-.04-.34-.11.32,0,.38.07,1.35.2,2.93,2.11,2.9,8.18-.2,22.65,1.96,35.89,0,2.88-3.32,12.02-4.31,14.14-.99,2.12-.9,3.25-.9,3.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.46,31.74c-.13,1.39.11,3.59-.11,4.78,0,0,.08,2.57-.77,4.29-.25.52-.56.94-.56.94,0,0-.6,1.03-.89,1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.91,115.13c.41-3.2.9-7.74,1.2-13.21.42-7.95.71-13.27-.37-19.89-.51-3.11.08-5.88-1.71-10.31-.84-2.07-1.22-4.3-1.11-6.53.05-1.01.1-2,.14-2.74l.34-7.5c.02-.52.02-1.03,0-1.55l-.15-11.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.5,34c.38.61.48,2.03.64,3.17.11.82.03,1.44,0,1.67-.33,2.76.37,7.78.5,9.58.35,4.52.72,4.24,1.38,9.16.32,2.38.06,5.39-.45,11.38-.28,3.3-.67,6.76-.67,6.76-.23,2-.43,3.57-.67,6.15-.14,1.48-.24,2.69-.3,3.49-.92,4.3-1.08,8.88-1.79,13.74-.81,5.53-1.36,10.79-1.72,15.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.75,114.82c.8-3.73,1.65-7.5,2.54-11.31.44-1.89.89-3.76,1.34-5.62.62.05,1.24.1,1.87.15.28,0,.58-.02.89-.05,1.03-.11,1.91-.36,2.62-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.7,114.82c-.25-3.19-.5-6.38-.75-9.56-.28-2.42-.55-4.83-.82-7.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.89,5.94c.04.45,0,4.68-.41,6.06-.1.32-.25,1.28-.93,2.18-1.31,1.69-2.29,2.57-4.09,3.24-1.42.53-1.53-.34-4.45.93-.42.18-.85.33-1.3.43l-1.21.28c-.36.08-.37.19-.71.32-.63.25-1.52.66-2.31,1.29-1.5,1.2-3.07,10.91-1.94,14.94,1.13,4.03.57,13.24,1.13,17.27.57,4.03.57,12.09,1.77,13.5,1.2,1.41,1.65,5.13,4.57,8.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.19,38.01s.13,4.74,1.48,6.18l-1.48-6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7.19,38.01s.13,4.74,1.48,6.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.16.45c.07,1.18-1.42,1.9-1.42,1.9v-.08c0,1.04.14,3.15-1.18,5.09-1.07,1.58-3.96,3.7-4.21,3.87-.11.11-.65.46-1.49.49-.82.02-1.37-.27-1.49-.38-.93-.78-2.86-1.64-4.69-3.65-1.99-2.19-1.86-4.55-1.97-5.73h.04s-1.27-.77-1.37-1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.16.45c.07,1.18-1.42,1.9-1.42,1.9v-.08c0,1.04.14,3.15-1.18,5.09-1.07,1.58-3.96,3.7-4.21,3.87-.11.11-.65.46-1.49.49-.82.02-1.37-.27-1.49-.38-.93-.78-2.86-1.64-4.69-3.65-1.99-2.19-1.86-4.55-1.97-5.73h.04s-1.27-.77-1.37-1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.67,62.31c0-.73.39-1.33.87-1.33s.87.59.87,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.77,47.96s-.01-.27,2.5-2.5c5.31-4.73,3-7,3.5-10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.39,48.96s.01-.27-2.5-2.5c-5.31-4.73-3-7-3.5-10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.13,78.29s1.84,17.98-.38,19.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.12,73.82c17.58,2.03,19.24,3.27,32.35-3.06l1.14,2.81c-8.63,6.25-20.39,6.29-33.71,3.21l.23-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.38,74.01s1.23,1.63.8,3.57l1.92-.55s.62-2.5-.62-3.6l-2.1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.35,74.93s-1.23,2-.8,4l-1.92-.56s-.62-2.46.62-3.6l2.1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.29,73.74s-.84,2.3-.55,4.55l-1.31-.63s-.44-2.72.41-4l1.45.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.8,71.22s.78,1.89.51,4.14l1.22-.63s.46-2.79-.33-4.07l-1.4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24.16,75.35l3.69-.14c.23,0,.22.34.24.54l.21,2.29c.02.21.06.59-.18.6l-3.71.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.25,76.95s.85.36,1.23-.17"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 29.87,
    cy: 76.59,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 25.9,
    cy: 77.04,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 23.18,
    cy: 76.97,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 32.19,
    cy: 76.01,
    r: 0.19
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.03,78.46c.28,3.74-.77,7.55-2.74,10.72,1.8-3.27,2.83-6.98,2.74-10.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.47,90.53c-.51,8.05-.98,16.26-3.3,24.01,2.03-7.82,2.72-16.02,3.3-24.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.81,90.53c.89,8.12,1.02,16.53-1.04,24.48,1.77-8,1.86-16.39,1.04-24.48h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorse1Male);
export default __webpack_public_path__ + "static/media/torse-1-male.b62a70b480b047465365b8c476fc928e.svg";
export { ForwardRef as ReactComponent };